import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { getCategory, getPopularPosts } from "@/pages/blog/blogData";
import { categoryBadgeClass } from "@/pages/blog/blogStyles";

export default function PopularPosts() {
  const popular = getPopularPosts(6);

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Mais acessados"
          badgeIcon="ri-fire-line"
          badgeTone="accent"
          title="Conteúdos mais acessados"
          description="Uma seleção dos conteúdos que mais ajudam quem precisa resolver uma dúvida específica de tecnologia e infraestrutura."
        />

        <div className="mx-auto mt-12 max-w-4xl divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-50">
          {popular.map((post, index) => {
            const category = getCategory(post.category);
            return (
              <Reveal key={post.slug} delay={index * 40}>
                <Link
                  to={`/blog/${post.slug}`}
                  className="group flex items-center gap-4 px-5 py-5 transition-colors hover:bg-background-100/70"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-primary-600">
                    <i className="ri-bookmark-line text-lg" aria-hidden="true"></i>
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="flex flex-wrap items-center gap-2">
                      <span
                        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${categoryBadgeClass(
                          category?.accent ?? "primary",
                        )}`}
                      >
                        {category?.name}
                      </span>
                    </span>
                    <span className="mt-1.5 block font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                      {post.title}
                    </span>
                  </span>
                  <span className="hidden shrink-0 items-center gap-1.5 text-xs text-foreground-400 sm:flex">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {post.readingTime}
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}